import { render, staticRenderFns } from "./modal-point-list.vue?vue&type=template&id=0dec3ef7&"
import script from "./modal-point-list.vue?vue&type=script&lang=js&"
export * from "./modal-point-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports